import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupG2 } from '../../../../../../../redux/app/annex6-v2/groups/group-g';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupG2PreviewProps = OwnProps;

function Annex6V2GroupG2Preview(props: Annex6V2GroupG2PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupG2;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemG2P2, itemG2P3, itemG2P4 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'G', '2', renderItemP2()],
            [null, null, '3', renderItemP3()],
            [null, null, '4', renderItemP4()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP2() {
        return (
            <h4 className="font-medium uppercase">
                Marpol sample seal no: {itemG2P2.marpolSampleSealNo}
            </h4>
        );
    }

    function renderItemP3() {
        return (
            <h4 className="font-medium uppercase">
                Fuel oil fully consumed on:{' '}
                {moment(itemG2P3.oilFullyConsumedDate).format('DD-MMM-YYYY')}{' '}
                (SMT)
            </h4>
        );
    }

    function renderItemP4() {
        const { date, method } = itemG2P4.disposed;
        return (
            <h4 className="font-medium uppercase">
                Marpol sample disposed on {moment(date).format('DD-MMM-YYYY')}{' '}
                (SMT) using {method}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupG2Preview;
